export default async (context) => {
    if(context.timestamp) {
        context.auth_counter_time(context)
    }

    await context.$store.dispatch('price/setPrice')

    await context.building_videos(context)

    context.rendering = true
}